// extracted by mini-css-extract-plugin
module.exports = {"root":"locations_root__lEuEh","title":"locations_title__y2EWV","tag_name":"locations_tag_name__XV4_P","list":"locations_list__2hBoG","name":"locations_name__QrDVl"};